(function () {
  'use strict';
  function initListicleHero(section) {
    if (!section) return;
    if (section.dataset.listicleInitialized === 'true') {
      return;
    }
    const slider = section.querySelector('.listicle-hero__slider');
    const track = section.querySelector('.listicle-hero__track');
    const slides = Array.from(
      section.querySelectorAll('.listicle-hero__slide')
    );
    const prevButton = section.querySelector('[data-listicle-prev]');
    const nextButton = section.querySelector('[data-listicle-next]');
    const dots = Array.from(
      section.querySelectorAll('[data-listicle-dot]')
    );
    if (!slider || !track || slides.length === 0) {
      return;
    }
    section.dataset.listicleInitialized = 'true';
    /* =====================================================
       SETTINGS
    ===================================================== */
    const autoplayEnabled =
      section.dataset.autoplay === 'true';
    const autoplaySpeed =
      parseInt(section.dataset.autoplaySpeed, 10) || 5000;
    /* =====================================================
       STATE
    ===================================================== */
    let currentIndex = 0;
    let autoplayTimer = null;
    let isDragging = false;
    let startX = 0;
    let dragDistance = 0;
    let pointerId = null;
    const SWIPE_THRESHOLD = 50;
    /* =====================================================
       UPDATE
    ===================================================== */
    function updateSlider(animate) {
      if (animate) {
        track.classList.remove('is-dragging');
      } else {
        track.classList.add('is-dragging');
      }
      const translateX = -(currentIndex * 100);
      track.style.transform =
        'translate3d(' + translateX + '%, 0, 0)';
      /* Active slide */
      slides.forEach(function (slide, index) {
        const active = index === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute(
          'aria-hidden',
          active ? 'false' : 'true'
        );
      });
      /* Active dot */
      dots.forEach(function (dot, index) {
        const active = index === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute(
          'aria-current',
          active ? 'true' : 'false'
        );
      });
    }
    /* =====================================================
       GO TO
    ===================================================== */
    function goToSlide(index) {
      if (slides.length <= 1) {
        return;
      }
      if (index < 0) {
        index = slides.length - 1;
      }
      if (index >= slides.length) {
        index = 0;
      }
      currentIndex = index;
      updateSlider(true);
    }
    /* =====================================================
       NEXT
    ===================================================== */
    function nextSlide() {
      goToSlide(currentIndex + 1);
    }
    /* =====================================================
       PREVIOUS
    ===================================================== */
    function previousSlide() {
      goToSlide(currentIndex - 1);
    }
    /* =====================================================
       AUTOPLAY
    ===================================================== */
    function stopAutoplay() {
      if (autoplayTimer !== null) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    function startAutoplay() {
      stopAutoplay();
      if (!autoplayEnabled || slides.length <= 1) {
        return;
      }
      autoplayTimer = setInterval(function () {
        if (!isDragging) {
          nextSlide();
        }
      }, autoplaySpeed);
    }
    function restartAutoplay() {
      startAutoplay();
    }
    /* =====================================================
       ARROWS
       IMPORTANT: arrows are handled separately
    ===================================================== */
    if (prevButton) {
      prevButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        previousSlide();
        restartAutoplay();
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        nextSlide();
        restartAutoplay();
      });
    }
    /* =====================================================
       DOTS
    ===================================================== */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        const index = parseInt(
          dot.getAttribute('data-listicle-dot'),
          10
        );
        if (Number.isNaN(index)) {
          return;
        }
        goToSlide(index);
        restartAutoplay();
      });
    });
    /* =====================================================
       DRAG START
       Don't start dragging when clicking an arrow
    ===================================================== */
    slider.addEventListener(
      'pointerdown',
      function (event) {
        if (
          event.target.closest(
            '[data-listicle-prev], [data-listicle-next], [data-listicle-dot]'
          )
        ) {
          return;
        }
        if (
          event.pointerType === 'mouse' &&
          event.button !== 0
        ) {
          return;
        }
        isDragging = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        dragDistance = 0;
        stopAutoplay();
        track.classList.add('is-dragging');
        if (slider.setPointerCapture) {
          try {
            slider.setPointerCapture(pointerId);
          } catch (error) {}
        }
      },
      { passive: true }
    );
    /* =====================================================
       DRAG MOVE
    ===================================================== */
    slider.addEventListener(
      'pointermove',
      function (event) {
        if (!isDragging) {
          return;
        }
        if (
          pointerId !== null &&
          event.pointerId !== pointerId
        ) {
          return;
        }
        dragDistance =
          event.clientX - startX;
        const width =
          slider.getBoundingClientRect().width;
        if (!width) {
          return;
        }
        let dragPercent =
          (dragDistance / width) * 100;
        /* Resistance */
        if (
          currentIndex === 0 &&
          dragPercent > 0
        ) {
          dragPercent *= 0.35;
        }
        if (
          currentIndex === slides.length - 1 &&
          dragPercent < 0
        ) {
          dragPercent *= 0.35;
        }
        const translate =
          -(currentIndex * 100) + dragPercent;
        track.style.transform =
          'translate3d(' +
          translate +
          '%, 0, 0)';
        if (Math.abs(dragDistance) > 8) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
    /* =====================================================
       DRAG END
    ===================================================== */
    function endDrag(event) {
      if (!isDragging) {
        return;
      }
      if (
        pointerId !== null &&
        event &&
        event.pointerId !== pointerId
      ) {
        return;
      }
      isDragging = false;
      track.classList.remove('is-dragging');
      if (
        Math.abs(dragDistance) >=
        SWIPE_THRESHOLD
      ) {
        if (dragDistance < 0) {
          nextSlide();
        } else {
          previousSlide();
        }
      } else {
        updateSlider(true);
      }
      if (
        slider.releasePointerCapture &&
        pointerId !== null
      ) {
        try {
          slider.releasePointerCapture(pointerId);
        } catch (error) {}
      }
      pointerId = null;
      startX = 0;
      dragDistance = 0;
      restartAutoplay();
    }
    slider.addEventListener(
      'pointerup',
      endDrag
    );
    slider.addEventListener(
      'pointercancel',
      endDrag
    );
    /* =====================================================
       KEYBOARD
    ===================================================== */
    slider.setAttribute('tabindex', '0');
    slider.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        previousSlide();
        restartAutoplay();
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        nextSlide();
        restartAutoplay();
      }
    });
    /* =====================================================
       HOVER
    ===================================================== */
    section.addEventListener('mouseenter', function () {
      stopAutoplay();
    });
    section.addEventListener('mouseleave', function () {
      restartAutoplay();
    });
    /* =====================================================
       PREVENT IMAGE DRAG
    ===================================================== */
    const images = section.querySelectorAll('.listicle-hero__image');
    images.forEach(function (image) {
      image.setAttribute('draggable', 'false');
      image.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
    });
    /* =====================================================
       INITIAL
    ===================================================== */
    currentIndex = 0;
    updateSlider(true);
    startAutoplay();
  }
  /* =======================================================
     INIT ALL
  ======================================================= */
  function initAll() {
    const sections = document.querySelectorAll('[data-listicle-hero]');
    sections.forEach(function (section) {
      initListicleHero(section);
    });
  }
  /* =======================================================
     DOM READY
  ======================================================= */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }
  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================= */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const section = event.target.querySelector &&
        event.target.querySelector(
          '[data-listicle-hero]'
        );
      if (section) {
        delete section.dataset.listicleInitialized;
        initListicleHero(section);
      }
    }
  );
})();

// (function () {
//   'use strict';

//   function initListicleHero(section) {
//     if (!section) {
//       return;
//     }

//     /*
//      * Prevent duplicate initialization.
//      * Shopify Theme Editor can load the same section again.
//      */
//     if (section.dataset.listicleInitialized === 'true') {
//       return;
//     }

//     const track = section.querySelector(
//       '.listicle-hero__track'
//     );

//     const viewport = section.querySelector(
//       '.listicle-hero__slider'
//     );

//     const slides = Array.from(
//       section.querySelectorAll(
//         '.listicle-hero__slide'
//       )
//     );

//     const prevButton = section.querySelector(
//       '[data-listicle-prev]'
//     );

//     const nextButton = section.querySelector(
//       '[data-listicle-next]'
//     );

//     const dots = Array.from(
//       section.querySelectorAll(
//         '[data-listicle-dot]'
//       )
//     );

//     if (!track || !viewport || slides.length === 0) {
//       return;
//     }

//     section.dataset.listicleInitialized = 'true';


//     /* ======================================================
//        SETTINGS
//     ====================================================== */

//     const autoplayEnabled =
//       section.dataset.autoplay === 'true';

//     const autoplaySpeed =
//       parseInt(
//         section.dataset.autoplaySpeed,
//         10
//       ) || 5000;


//     /* ======================================================
//        STATE
//     ====================================================== */

//     let currentIndex = 0;

//     let autoplayTimer = null;

//     let isDragging = false;

//     let startX = 0;

//     let currentX = 0;

//     let dragDistance = 0;

//     let pointerId = null;

//     let isMouseInside = false;

//     const SWIPE_THRESHOLD = 50;


//     /* ======================================================
//        UPDATE SLIDER
//     ====================================================== */

//     function updateSlider(animate = true, dragOffset = 0) {

//       if (animate) {
//         track.classList.remove('is-dragging');
//       } else {
//         track.classList.add('is-dragging');
//       }


//       /*
//        Every slide is exactly 100% of the viewport.

//        currentIndex = 0
//        translate = 0%

//        currentIndex = 1
//        translate = -100%

//        currentIndex = 2
//        translate = -200%
//       */

//       const baseOffset =
//         currentIndex * 100;

//       const translate =
//         -baseOffset + dragOffset;


//       track.style.transform =
//         'translate3d(' +
//         translate +
//         '%, 0, 0)';


//       /* ----------------------------------------------
//          Active slide
//       ---------------------------------------------- */

//       slides.forEach(function (slide, index) {

//         const active =
//           index === currentIndex;

//         slide.classList.toggle(
//           'is-active',
//           active
//         );

//         slide.setAttribute(
//           'aria-hidden',
//           active ? 'false' : 'true'
//         );

//       });


//       /* ----------------------------------------------
//          Dots
//       ---------------------------------------------- */

//       dots.forEach(function (dot, index) {

//         const active =
//           index === currentIndex;

//         dot.classList.toggle(
//           'is-active',
//           active
//         );

//         dot.setAttribute(
//           'aria-current',
//           active ? 'true' : 'false'
//         );

//       });

//     }


//     /* ======================================================
//        GO TO SLIDE
//     ====================================================== */

//     function goToSlide(index) {

//       if (slides.length <= 1) {
//         currentIndex = 0;
//         updateSlider(true);
//         return;
//       }


//       /*
//        * Infinite looping.
//        */

//       if (index < 0) {
//         index = slides.length - 1;
//       }

//       if (index >= slides.length) {
//         index = 0;
//       }


//       currentIndex = index;

//       updateSlider(true);

//     }


//     /* ======================================================
//        NEXT / PREVIOUS
//     ====================================================== */

//     function nextSlide() {

//       goToSlide(
//         currentIndex + 1
//       );

//     }


//     function previousSlide() {

//       goToSlide(
//         currentIndex - 1
//       );

//     }


//     /* ======================================================
//        AUTOPLAY
//     ====================================================== */

//     function stopAutoplay() {

//       if (autoplayTimer !== null) {

//         window.clearInterval(
//           autoplayTimer
//         );

//         autoplayTimer = null;

//       }

//     }


//     function startAutoplay() {

//       stopAutoplay();

//       if (
//         !autoplayEnabled ||
//         slides.length <= 1
//       ) {
//         return;
//       }


//       autoplayTimer =
//         window.setInterval(
//           function () {

//             /*
//              * Don't autoplay while user is
//              * interacting with slider.
//              */

//             if (
//               isDragging ||
//               isMouseInside
//             ) {
//               return;
//             }

//             nextSlide();

//           },
//           autoplaySpeed
//         );

//     }


//     function restartAutoplay() {

//       startAutoplay();

//     }


//     /* ======================================================
//        ARROWS
//     ====================================================== */

//     if (nextButton) {

//       nextButton.addEventListener(
//         'click',
//         function (event) {

//           event.preventDefault();
//           event.stopPropagation();

//           nextSlide();

//           restartAutoplay();

//         }
//       );

//     }


//     if (prevButton) {

//       prevButton.addEventListener(
//         'click',
//         function (event) {

//           event.preventDefault();
//           event.stopPropagation();

//           previousSlide();

//           restartAutoplay();

//         }
//       );

//     }


//     /* ======================================================
//        DOTS
//     ====================================================== */

//     dots.forEach(function (dot) {

//       dot.addEventListener(
//         'click',
//         function (event) {

//           event.preventDefault();
//           event.stopPropagation();

//           const index =
//             parseInt(
//               dot.dataset.listicleDot,
//               10
//             );

//           if (
//             Number.isNaN(index) ||
//             index < 0 ||
//             index >= slides.length
//           ) {
//             return;
//           }


//           currentIndex = index;

//           updateSlider(true);

//           restartAutoplay();

//         }
//       );

//     });


//     /* ======================================================
//        POINTER DOWN
//        Mouse + Touch
//     ====================================================== */

//     function pointerDown(event) {

//       /*
//        * Only allow left mouse button.
//        * Touch / pen doesn't use this restriction.
//        */

//       if (
//         event.pointerType === 'mouse' &&
//         event.button !== 0
//       ) {
//         return;
//       }


//       isDragging = true;

//       pointerId =
//         event.pointerId;

//       startX =
//         event.clientX;

//       currentX =
//         event.clientX;

//       dragDistance = 0;


//       stopAutoplay();


//       track.classList.add(
//         'is-dragging'
//       );


//       /*
//        * Capture the pointer so drag continues
//        * even if pointer leaves the slider.
//        */

//       if (
//         viewport.setPointerCapture
//       ) {

//         try {

//           viewport.setPointerCapture(
//             pointerId
//           );

//         } catch (error) {}

//       }


//       /*
//        * Don't let browser start native image dragging.
//        */

//       event.preventDefault();

//     }


//     /* ======================================================
//        POINTER MOVE
//     ====================================================== */

//     function pointerMove(event) {

//       if (!isDragging) {
//         return;
//       }


//       if (
//         pointerId !== null &&
//         event.pointerId !== pointerId
//       ) {
//         return;
//       }


//       currentX =
//         event.clientX;


//       dragDistance =
//         currentX - startX;


//       const viewportWidth =
//         viewport.getBoundingClientRect().width;


//       if (!viewportWidth) {
//         return;
//       }


//       /*
//        * Convert pixel drag into percentage.
//        */

//       let dragPercent =
//         (dragDistance / viewportWidth) * 100;


//       /*
//        * Add resistance at first/last slide.
//        */

//       if (
//         currentIndex === 0 &&
//         dragPercent > 0
//       ) {

//         dragPercent *= 0.35;

//       }


//       if (
//         currentIndex === slides.length - 1 &&
//         dragPercent < 0
//       ) {

//         dragPercent *= 0.35;

//       }


//       updateSlider(
//         false,
//         dragPercent
//       );


//       /*
//        * Prevent vertical page scrolling
//        * once horizontal drag is obvious.
//        */

//       if (
//         Math.abs(dragDistance) > 8
//       ) {

//         event.preventDefault();

//       }

//     }


//     /* ======================================================
//        POINTER UP
//     ====================================================== */

//     function pointerUp(event) {

//       if (!isDragging) {
//         return;
//       }


//       if (
//         pointerId !== null &&
//         event.pointerId !== pointerId
//       ) {
//         return;
//       }


//       isDragging = false;


//       track.classList.remove(
//         'is-dragging'
//       );


//       /*
//        * Release pointer capture.
//        */

//       if (
//         viewport.releasePointerCapture &&
//         pointerId !== null
//       ) {

//         try {

//           viewport.releasePointerCapture(
//             pointerId
//           );

//         } catch (error) {}

//       }


//       /*
//        * Move to next / previous slide
//        * only when threshold is reached.
//        */

//       if (
//         Math.abs(dragDistance) >=
//         SWIPE_THRESHOLD
//       ) {

//         if (dragDistance < 0) {

//           nextSlide();

//         } else {

//           previousSlide();

//         }

//       } else {

//         /*
//          * Small movement = snap back.
//          */

//         updateSlider(true);

//       }


//       pointerId = null;

//       startX = 0;

//       currentX = 0;

//       dragDistance = 0;


//       /*
//        * Restart autoplay after interaction.
//        */

//       restartAutoplay();

//     }


//     /* ======================================================
//        POINTER CANCEL
//     ====================================================== */

//     function pointerCancel(event) {

//       if (!isDragging) {
//         return;
//       }


//       if (
//         pointerId !== null &&
//         event.pointerId !== pointerId
//       ) {
//         return;
//       }


//       isDragging = false;

//       pointerId = null;

//       startX = 0;

//       currentX = 0;

//       dragDistance = 0;


//       track.classList.remove(
//         'is-dragging'
//       );


//       updateSlider(true);

//       restartAutoplay();

//     }


//     /* ======================================================
//        POINTER EVENTS
//     ====================================================== */

//     viewport.addEventListener(
//       'pointerdown',
//       pointerDown,
//       {
//         passive: false
//       }
//     );


//     viewport.addEventListener(
//       'pointermove',
//       pointerMove,
//       {
//         passive: false
//       }
//     );


//     viewport.addEventListener(
//       'pointerup',
//       pointerUp
//     );


//     viewport.addEventListener(
//       'pointercancel',
//       pointerCancel
//     );


//     viewport.addEventListener(
//       'lostpointercapture',
//       function () {

//         if (isDragging) {

//           isDragging = false;

//           pointerId = null;

//           dragDistance = 0;

//           track.classList.remove(
//             'is-dragging'
//           );

//           updateSlider(true);

//           restartAutoplay();

//         }

//       }
//     );


//     /* ======================================================
//        KEYBOARD
//     ====================================================== */

//     viewport.setAttribute(
//       'tabindex',
//       '0'
//     );


//     viewport.addEventListener(
//       'keydown',
//       function (event) {

//         if (
//           event.key === 'ArrowRight'
//         ) {

//           event.preventDefault();

//           nextSlide();

//           restartAutoplay();

//         }


//         if (
//           event.key === 'ArrowLeft'
//         ) {

//           event.preventDefault();

//           previousSlide();

//           restartAutoplay();

//         }

//       }
//     );


//     /* ======================================================
//        MOUSE ENTER / LEAVE
//     ====================================================== */

//     section.addEventListener(
//       'mouseenter',
//       function () {

//         isMouseInside = true;

//         stopAutoplay();

//       }
//     );


//     section.addEventListener(
//       'mouseleave',
//       function () {

//         isMouseInside = false;

//         restartAutoplay();

//       }
//     );


//     /* ======================================================
//        IMAGE DRAG PREVENTION
//     ====================================================== */

//     const images =
//       section.querySelectorAll(
//         '.listicle-hero__image'
//       );


//     images.forEach(function (image) {

//       image.setAttribute(
//         'draggable',
//         'false'
//       );


//       image.addEventListener(
//         'dragstart',
//         function (event) {

//           event.preventDefault();

//         }
//       );

//     });


//     /* ======================================================
//        INITIAL STATE
//     ====================================================== */

//     currentIndex = 0;

//     updateSlider(true);

//     startAutoplay();

//   }


//   /* ========================================================
//      INITIALIZE ALL SECTIONS
//   ======================================================== */

//   function initAll() {

//     const sections =
//       document.querySelectorAll(
//         '[data-listicle-hero]'
//       );


//     sections.forEach(function (section) {

//       initListicleHero(section);

//     });

//   }


//   /* ========================================================
//      DOM READY
//   ======================================================== */

//   if (
//     document.readyState === 'loading'
//   ) {

//     document.addEventListener(
//       'DOMContentLoaded',
//       initAll
//     );

//   } else {

//     initAll();

//   }


//   /* ========================================================
//      SHOPIFY THEME EDITOR
//   ======================================================== */

//   document.addEventListener(
//     'shopify:section:load',
//     function (event) {

//       const section =
//         event.target.querySelector &&
//         event.target.querySelector(
//           '[data-listicle-hero]'
//         );


//       if (section) {

//         /*
//          * Reset in case Shopify reuses markup.
//          */

//         delete section.dataset.listicleInitialized;

//         initListicleHero(section);

//       }

//     }
//   );


//   /*
//    * Shopify can also re-render sections.
//    */

//   document.addEventListener(
//     'shopify:section:reorder',
//     function () {

//       initAll();

//     }
//   );


// })();
